module.exports = __webpack_public_path__ + "06_mole.e457acea.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer2/06_mole.png
// module id = Y9xu
// module chunks = 0